// Copyright 2022, Imprivata, Inc.  All rights reserved.

export const DISABLE_EA_MOCK = 'DISABLE_EA_MOCK';
